import { render, staticRenderFns } from "./NavDrawerDGNDD.vue?vue&type=template&id=2c6a7940&scoped=true"
import script from "./NavDrawerDGNDD.vue?vue&type=script&lang=ts"
export * from "./NavDrawerDGNDD.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a7940",
  null
  
)

export default component.exports